import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Loader from '../../Loader';
import {
  ClearButton,
  ContainerPadding,
  StyledContainer,
  StyledTitle,
  StyledValue,
  StyledIcon
} from './styled';
import Icon from '../../Icon';
import DeleteIcon from '../../../public/static/images/new_search/icons/icon-delete.svg';

export const Selector = ({
  icon,
  stat,
  name,
  title,
  value,
  onClick,
  cypress,
  clearHandler,
  loading = false,
  withArrow = true,
  isDownArrow = true
}) => {
  const displayClearButton = value && clearHandler;
  const displayArrow = withArrow && !displayClearButton;
  const calcSafeSpace = () => {
    let temp = 0;
    if (displayClearButton) {
      temp = 60;
    }
    if (displayArrow) {
      temp = 50;
    }
    if (icon) {
      temp += 35;
    }
    return temp;
  };

  return (
    <StyledContainer
      data-stat={stat}
      onClick={onClick}
      withArrow={displayArrow}
      isDownArrow={isDownArrow}
    >
      <Field name={name} component="input" type="hidden" />
      {icon && (
        <StyledIcon>
          <Icon width={22} height={22} indent={false} IconComponent={icon} />
        </StyledIcon>
      )}
      <ContainerPadding safeSpace={calcSafeSpace()}>
        <StyledTitle data-cy={`${cypress}-title`}>{title}</StyledTitle>
        <Loader loading={loading} optionalClass="city__loader">
          <StyledValue data-cy={cypress}>{value}</StyledValue>
        </Loader>
      </ContainerPadding>
      {displayClearButton && (
        <ClearButton
          type="button"
          onClick={clearHandler}
          data-cy={`${cypress}-clear`}
        >
          <Icon
            width={15}
            height={15}
            indent={false}
            IconComponent={DeleteIcon}
          />
        </ClearButton>
      )}
    </StyledContainer>
  );
};

Selector.propTypes = {
  icon: PropTypes.func,
  stat: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  withArrow: PropTypes.bool,
  cypress: PropTypes.string,
  isDownArrow: PropTypes.bool,
  clearHandler: PropTypes.func
};
